import { ValidationCallback } from '~/types/types'
export const alpha: ValidationCallback = (value: any, param?: any, customMessage?: string) => /^[a-zа-я\s)(-]+$/ig.test((value as string).toLowerCase()) || (customMessage || 'Разрешены только буквы, пробел и символ тире')
